// istanbul ignore file
import { Box, Breadcrumbs, styled, Tab, Tabs, Typography } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers-pro'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { Button } from '../../../components/Button'
import dayjs from 'dayjs'
import React, { useCallback, useEffect } from 'react'
import { type RootState } from '../../../store'
import './assetDashboard.css'
import breadcrumimg from '../../../assets/site-img.svg'
import { MemoSummary } from './summary'
import AssetScore from './assetScore'
import LanguageStrings from '../../../i18n/locales'
import { useLocation } from 'react-router-dom'
import SaveDefaultButton from './saveDefaultButton'
import { type Option, GenXDropdown } from '../../../components/GenXDropdown'
import { MemorizedBookmark } from '../../bookmarks-home/components/ToggleBookmarkComponent'
import { fetchParameterConfiguration } from '../../services/redux/ParameterConfigurationActionCreators'
import { type ConnectedProps, connect } from 'react-redux'
import { MemorizedGatewayStatus } from './GatewayStatus'
import { getSaveDeafaultWidget } from '../../device-dashboard/redux/actionCreator'
import { useDispatch } from 'react-redux'
import { SaveDefaultViewObjectUpdateAction } from '../../device-dashboard/redux/saveDefaultViewObjectSlice'
import { MemoSaveDefaultViewWrapper } from './SaveDefaultViewWrapper'
import { DEFAULT_DATA_WINDOW_HOURS } from '../../../utils/DashboardContants'
import { getHealthScoreAssetservice } from '../redux/actionCreator'
import { GetSaveDefaultWidgeLoadingAction } from '../../device-dashboard/redux/getSaveDefaultViewServiceSlice'

const AssetDashboardStrings = LanguageStrings().AssetDashboardStrings

const WhiteDatePicker = styled(DateTimePicker)({
  '& .MuiInputBase-input': {
    color: '#D0D0D0'
  },
  '& .MuiInputBase-root': {
    background: '#5c5b5bdd',
    height: '40px',
    overflow: 'unset',
    minWidth: '150px' // Corrected the width unit here
  },
  '& .MuiStack-root': {
    overflow: 'unset !important',
    paddingTop: '1px !important',
    '& .MuiTextField-root': {
      // Add your styles for .MuiTextField-root here
      backgroundColor: '#ffffff',
      minWidth: '100px', // Example style
      border: '1px solid #ccc' // Example style
    }
  },
  // Change icon color when disabled
  '& .Mui-disabled .MuiIconButton-root': {
    color: '#888888 !important' // Set your desired disabled color here
  }
})

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

const CustomTabPanel = React.memo(({ children, value, index, ...other }: TabPanelProps) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>)
})
CustomTabPanel.displayName = 'CustomTabPanel'

const assetDashboardMain = (props: PropsFromRedux): JSX.Element => {
  const [tabValue, setTabValue] = React.useState(0)
  const [startDate, setStartDate] = React.useState('')
  const [endDate, setEndDate] = React.useState('')
  const [golive, setGolive] = React.useState(true)
  const [isGolive, setIsGolive] = React.useState(true)
  const [endDateValue, setEndDateValue] = React.useState(null)
  const [startDateValue, setStartDateValue] = React.useState(null)
  const [oldParentAssetId, setOldParentAssetId] = React.useState<any>(null) // For Re mounting when change asset
  const [selectedDateRange, setSelectedDateRange] = React.useState<Option | null>(null)
  const [customeDateSelection, setCustomeDateSelection] = React.useState(false)
  const [customeSelection, setCustomeSelection] = React.useState(false)
  const [refreshAllow, setRefreshAllow] = React.useState(true)
  const [render, setRender] = React.useState(true)
  const assetStatusDefaultView = React.useMemo<boolean>(() => { return false }, [])
  const stateLocation = useLocation()
  interface StateLocation {
    parentSiteId: string
    parentAssetId: string
    parentAssetTypeId: string
    siteName: string
    assetName: string
    deviceName: string
  }
  const dispatch = useDispatch()
  // istanbul ignore next
  const navigateState = stateLocation.state as StateLocation | null
  const parentSiteName = navigateState != null ? navigateState.siteName : ''
  const parentAssetName = navigateState != null ? navigateState.assetName : ''
  const parentAssetId = navigateState != null ? navigateState.parentAssetId : ''
  const parentSiteId = navigateState != null ? navigateState.parentSiteId : ''
  const parentAssetTypeId = navigateState != null ? navigateState.parentAssetTypeId : ''

  React.useEffect(() => {
    setSelectedDateRange(null)
    setStartDateValue(null)
    setEndDateValue(null)
    setIsGolive(true)
    const utcDate = dayjs.utc()
    const today = utcDate.utc().format('YYYY-MM-DD HH:mm:ss')
    const defaultDataWindowUTC = utcDate
      .utc()
      .subtract(DEFAULT_DATA_WINDOW_HOURS, 'hour')
      .format('YYYY-MM-DD HH:mm:ss')
    setStartDate(defaultDataWindowUTC)
    setEndDate(today)
    dispatch(SaveDefaultViewObjectUpdateAction(null))
    props.getSaveDeafaultWidget(parentSiteId, parentAssetId, parentAssetId)
    setOldParentAssetId(parentAssetId)
  }, [parentAssetId])

  const handleStartDate = (val: any): void => {
    setCustomeDateSelection(true)
    const utcDate = dayjs(val)
    const formattedDate = utcDate.utc().format('YYYY-MM-DD HH:mm:ss')
    setStartDate(formattedDate)
    setStartDateValue(val)
    setEndDate('')
    setEndDateValue(null)

    setGolive(false)
    setCustomeSelection(true)
    setIsGolive(false)
  }

  const handleEndDate = (val: any): void => {
    if (startDateValue !== null && val !== null) setSelectedDateRange(null)
    setCustomeDateSelection(true)
    const utcDate = dayjs(val)
    const formattedDate = utcDate.utc().format('YYYY-MM-DD HH:mm:ss')
    setEndDate(formattedDate)
    setEndDateValue(val)
    setGolive(false)
    setCustomeSelection(true)
    setIsGolive(false)
  }
  const stopInterval = useCallback(() => {
    setRefreshAllow(false)
  }, [])

  const startInterval = useCallback(() => {
    setRefreshAllow(true)
  }, [])

  React.useEffect(() => {
    if (refreshAllow && !customeDateSelection && startDateValue === null && endDateValue === null && selectedDateRange === null) {
      const interval = setInterval(() => {
        handleGoLiveView()
        props.getSaveDeafaultWidget(parentSiteId, parentAssetId, parentAssetId)
        setRender(true)
      }, 300000)

      return () => {
        clearInterval(interval)
      }
    }
  }, [parentAssetId, refreshAllow, startDateValue, endDateValue, selectedDateRange])

  const handleGoLiveView = (): void => {
    props.resetSaveDefaultView()
    setOldParentAssetId(null)
    setCustomeDateSelection(false)
    setCustomeSelection(false)
    setSelectedDateRange(null)
    setStartDateValue(null)
    setEndDateValue(null)
    const utcDate = dayjs.utc()
    const today = utcDate.format('YYYY-MM-DD HH:mm:ss')
    const defaultDataWindowUTC = utcDate.subtract(DEFAULT_DATA_WINDOW_HOURS, 'hour')
    setStartDate(defaultDataWindowUTC.format('YYYY-MM-DD HH:mm:ss'))
    setEndDate(today)
    setGolive((prevState) => !prevState) // Toggle the golive state to ensure re-render
    setIsGolive(true)
    setRender(false)
    setOldParentAssetId(parentAssetId)
  }

  useEffect(() => {
    setRender(true)
  }, [golive])

  const handleDataRangeChange = (selectedDateRange: Option | null): void => {
    setStartDateValue(null)
    setEndDateValue(null)
    setCustomeDateSelection(true)
    setSelectedDateRange(selectedDateRange)
    setIsGolive(false)
    const endDateLocal = dayjs()
    let startDate = ''
    let endDate = endDateLocal.format('YYYY-MM-DD HH:mm:ss')

    const getStartDate = (
      unit: dayjs.OpUnitType,
      subtractValue = 0,
      startOfUnit = true
    ): string => {
      const date =
        typeof subtractValue === 'number' &&
        !isNaN(subtractValue) &&
        subtractValue !== 0
          ? endDateLocal.subtract(subtractValue, unit as dayjs.ManipulateType)
          : endDateLocal
      return startOfUnit
        ? date.startOf(unit).utc().format('YYYY-MM-DD HH:mm:ss')
        : date.endOf(unit).utc().format('YYYY-MM-DD HH:mm:ss')
    }

    switch (selectedDateRange?.value) {
      case 'Today':
        startDate = getStartDate('day')
        endDate = endDateLocal.utc().format('YYYY-MM-DD HH:mm:ss')
        break
      case 'Yesterday':
        startDate = getStartDate('day', 1)
        endDate = getStartDate('day', 1, false)
        break
      case 'This Hour':
        startDate = getStartDate('hour')
        endDate = endDateLocal.utc().format('YYYY-MM-DD HH:mm:ss')
        break
      case 'Last Hour':
        startDate = getStartDate('hour', 1)
        endDate = getStartDate('hour', 1, false)
        break
      case 'Last 24 Hours':
        startDate = getStartDate('hour', 24)
        endDate = getStartDate('hour', 0, false)
        break
      case 'This Week':
        startDate = getStartDate('week')
        endDate = endDateLocal.utc().format('YYYY-MM-DD HH:mm:ss')
        break
      case 'Last Week':
        startDate = getStartDate('week', 1)
        endDate = getStartDate('week', 1, false)
        break
      case 'This Month':
        startDate = getStartDate('month')
        endDate = endDateLocal.utc().format('YYYY-MM-DD HH:mm:ss')
        break
      case 'Last Month':
        startDate = getStartDate('month', 1)
        endDate = getStartDate('month', 1, false)
        break
      default:
        break
    }

    setStartDate(startDate)
    setEndDate(endDate)
  }

  const DataRangeOptions = React.useMemo<any>(() => {
    return [
      { label: 'Today', value: 'Today' },
      { label: 'Yesterday', value: 'Yesterday' },
      { label: 'This Hour', value: 'This Hour' },
      { label: 'Last Hour', value: 'Last Hour' },
      { label: 'Last 24 Hours', value: 'Last 24 Hours' },
      { label: 'This Week', value: 'This Week' },
      { label: 'Last Week', value: 'Last Week' },
      { label: 'This Month', value: 'This Month' },
      { label: 'Last Month', value: 'Last Month' }
    ]
  }, [])

  useEffect(() => {
    props.getDeviceParameterService(navigateState?.parentSiteId ?? '', navigateState?.parentAssetId ?? '')
  }, [navigateState?.parentAssetId])

  function a11yProps (index: number): { id: string, 'aria-controls': string } {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`
    }
  }

  const handleChange = (
    event: React.SyntheticEvent,
    newValue: number
  ): void => {
    setTabValue(newValue)
    if (newValue === 0) props.getHealthScoreAssetservice(parentSiteId, parentAssetId)
  }

  return (
    <>
      <div className='main-dashbaord'>
        <div
          style={{
            margin: '10px 0px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          {/* Breadcrumb */}
          <Breadcrumbs
            aria-label='breadcrumb'
            style={{
              color: 'white',
              fontSize: '20px',
              fontFamily: 'Honeywell Sans Web'
            }}
          >
            <img src={breadcrumimg} />
            <Typography
              sx={{ fontSize: '20px', fontFamily: 'Honeywell Sans Web' }}
              className='breadcrumb-title'
              variant='body1'
            >
              {parentSiteName}
            </Typography>
            <Typography
              sx={{ fontSize: '20px', fontFamily: 'Honeywell Sans Web' }}
              className='breadcrumb-title'
              variant='body1'
            >
              {parentAssetName}
            </Typography>
          </Breadcrumbs>
          {tabValue !== 1 && (
            <>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <MemorizedBookmark
                  parentId={null}
                  siteId={navigateState?.parentSiteId ?? null}
                  assetId={navigateState?.parentAssetId ?? null}
                  deviceId={null}
                />
                {/* "Go Live" Button */}
                <Button onClick={handleGoLiveView} className='go-live-default'>
                  {AssetDashboardStrings.goLiveBtn}
                </Button>

                <GenXDropdown
                  placeholder={'Select Quick Range'}
                  value={selectedDateRange}
                  options={DataRangeOptions}
                  onSelect={handleDataRangeChange}
                  width={200}
                />
                {/* Date Range Picker */}
                <span className='date-selection'>
                  <div className='C-datePicke' style={{ marginLeft: '10px' }}>
                    {/* <span className='picker-label'> From : </span> */}
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={['DateTimePicker']} sx={{ overflow: 'hidden', paddingTop: '0px', marginRight: 1 }}>
                        <WhiteDatePicker
                          data-testid='date-picker'
                          disableFuture
                          value={startDateValue}
                          slotProps={{
                            textField: {
                              fullWidth: false,
                              style: { minWidth: 'auto' }, // Adjust width as needed
                              inputProps: { readOnly: true }, // Disable manual date entry
                              placeholder: 'Select start date' // Add placeholder here
                            }
                          }}
                          onAccept={(val: any) => {
                            handleStartDate(dayjs(val))
                          }}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </div>
                  <div className='C-datePicke'>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={['DateTimePicker']} sx={{ overflow: 'hidden', paddingTop: '0px', marginRight: 1 }}>
                        <WhiteDatePicker
                          data-testid='date-picker'
                          value={endDateValue}
                          disabled={startDateValue === null}
                          disableFuture
                          minDate={dayjs(startDateValue)}
                          maxDate={dayjs(startDateValue).add(30, 'day')}
                          slotProps={{
                            textField: {
                              fullWidth: false,
                              style: { minWidth: 'auto' }, // Adjust width as needed
                              inputProps: { readOnly: true },
                              placeholder: 'Select end date' // Add placeholder here
                            }
                          }}
                          onAccept={(val: any) => {
                            handleEndDate(dayjs(val))
                          }}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </div>
                </span>
                <SaveDefaultButton parentAssetId={parentAssetId} />
                <MemoSaveDefaultViewWrapper />
              </div>
            </>
          )}
        </div>
        {tabValue !== 1 && (
          <MemorizedGatewayStatus parentSiteId={parentSiteId} parentAssetTypeId={parentAssetTypeId} parentAssetId={parentAssetId} Golive={golive} />
        )}
      </div>
      <div>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
  <Tabs
    value={tabValue}
    onChange={handleChange}
    aria-label='basic tabs example'
  >
    <Tab
      sx={{ color: 'gray' }}
      label={AssetDashboardStrings.summaryTab}
      {...a11yProps(0)}
    />
    <Tab
      sx={{ color: 'gray' }}
      label={AssetDashboardStrings.assetScore}
      {...a11yProps(1)}
    />
  </Tabs>
</Box>

  <div style={{ display: tabValue === 0 ? 'block' : 'none' }} >
    {oldParentAssetId === parentAssetId && render && (
      <MemoSummary
        startDate={startDate}
        endDate={endDate}
        Golive={true}
        IsGolive={isGolive}
        customeDateSelection={customeDateSelection}
        saveDefaultView={assetStatusDefaultView}
        customeSelection={customeSelection}
        stopInterval={stopInterval}
        startInterval={startInterval}
        tabSwitch={tabValue}
      />
    )}
  </div>

{tabValue === 1 && (
  <CustomTabPanel value={tabValue} index={1}>
    <AssetScore />
  </CustomTabPanel>
)}
      </div>
    </>
  )
}
interface DispatchToProps {
  resetSaveDefaultView: () => void
  getDeviceParameterService: (siteID: string, assetID: string) => void
  getSaveDeafaultWidget: (parentSiteId: string, parentAssetId: string, deviceIds: string) => void
  getHealthScoreAssetservice: (siteId: string, deviceId: string) => void
}
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface StateToProps {
}
const mapStateToProps = (state: RootState): StateToProps => ({
})

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  resetSaveDefaultView: () => dispatch(GetSaveDefaultWidgeLoadingAction()),
  getDeviceParameterService: (siteID: string, assetID: string) =>
    dispatch(fetchParameterConfiguration(siteID, assetID)),
  getSaveDeafaultWidget: (siteID: string, parentAssetId: string, deviceIds: string) => dispatch(getSaveDeafaultWidget(siteID, parentAssetId, deviceIds)),
  getHealthScoreAssetservice: (siteId: string, deviceId: string) => dispatch(getHealthScoreAssetservice(siteId, deviceId))
})

const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(assetDashboardMain)
